import React, { useState } from "react";
import "./AdminAllUserVisualisation.css";
import AggregatedPersonalityCharts from "./AggregatedUserCharts/AggregatedPersonalityCharts";

const AdminAllUserPersonalityVisualisation = ({ allUserData }) => {
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  if (!allUserData || allUserData.length === 0) return null;

  return (
    <div className="admin-visualisation">
      <h2>All Users – Personality Visualisation</h2>

      <AggregatedPersonalityCharts
        allUserData={allUserData}
        startDate={startDate}
        endDate={endDate}
        setStartDate={setStartDate}
        setEndDate={setEndDate}
      />
    </div>
  );
};

export default AdminAllUserPersonalityVisualisation;